import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import { registerSW } from 'virtual:pwa-register';

import toast from 'react-hot-toast';

// Gentle PWA Update Prompt
const updateSW = registerSW({
  onNeedRefresh() {
    toast((t) => (
      <div className="flex flex-col gap-3">
        <p className="font-medium text-gray-800 dark:text-gray-200">
          A new breath of the Sanctuary is available.
        </p>
        <button 
           onClick={() => { updateSW(true); toast.dismiss(t.id); }}
           className="bg-brand-blue hover:bg-brand-blue/90 text-white px-4 py-2 rounded-xl text-sm font-semibold transition-colors"
        >
           Refresh Sanctuary
        </button>
      </div>
    ), { 
      duration: Infinity,
      position: 'bottom-center',
      style: {
        background: 'var(--tw-prose-body)', // will inherit theme
        color: 'var(--tw-prose-headings)',
        padding: '16px',
        borderRadius: '16px',
      }
    });
  },
  onOfflineReady() {
    console.log("Sanctuary is ready for offline journey.");
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);
